/**
 * <cart-notification-items> — qty + remove controls inside the
 * "Item added to your cart" popup. Extends CartItems so it inherits the
 * standard /cart/change.js flow + section re-rendering.
 */
(function defineWhenReady() {
  if (typeof CartItems === 'undefined') {
    document.addEventListener('DOMContentLoaded', defineWhenReady, { once: true });
    return;
  }
  if (customElements.get('cart-notification-items')) return;

  class CartNotificationItems extends CartItems {
    getSectionsToRender() {
      // CartItems.updateQuantity replaces innerHTML at:
      //   getElementById(section.id).querySelector(section.selector) || getElementById(section.id)
      // and the inner HTML comes from getSectionInnerHTML(sectionHtml, section.selector)
      // which queries `.shopify-section` wrapper from the response.
      //
      // For our notification, the page-side wrapper is the div #cart-notification-product
      // which is NOT itself a .shopify-section — so we use selector '.shopify-section'
      // to peel the response wrapper, and the element-side fallback (no querySelector
      // match) writes innerHTML straight into the wrapper.
      const sections = [
        {
          id: 'cart-notification-product',
          section: 'cart-notification-product',
          selector: '.shopify-section',
        },
        {
          id: 'cart-notification-footer',
          section: 'cart-notification-footer',
          selector: '.shopify-section',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
      if (document.querySelector('cart-drawer')) {
        sections.push({
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        });
      }
      // When the popup is opened on /cart, also re-render the cart page's
      // line-items table and footer so the two qty editors stay in sync.
      const mainCartItems = document.getElementById('main-cart-items');
      if (mainCartItems && mainCartItems.dataset.id) {
        sections.push({
          id: 'main-cart-items',
          section: mainCartItems.dataset.id,
          selector: '.js-contents',
        });
      }
      const mainCartFooter = document.getElementById('main-cart-footer');
      if (mainCartFooter && mainCartFooter.dataset.id) {
        sections.push({
          id: 'main-cart-footer',
          section: mainCartFooter.dataset.id,
          selector: '.js-contents',
        });
      }
      return sections;
    }
  }

  customElements.define('cart-notification-items', CartNotificationItems);
})();
